<script setup lang="ts">
import type { PrimitiveProps } from 'reka-ui'
import type { HTMLAttributes } from 'vue'

import { Spinner } from '~ds/components/ui/spinner'
import { cn } from '~ds/lib/utils'
import { Primitive } from 'reka-ui'

import type { ButtonVariants } from '.'

import { buttonVariants } from '.'

interface Props extends PrimitiveProps {
  variant?: ButtonVariants['variant'];
  size?: ButtonVariants['size'];
  loading?: boolean;
  /** Accessible name of the loader while `loading` (e.g. "Please wait"); defaults to the Spinner's own */
  loadingLabel?: string;
  class?: HTMLAttributes['class'];
}

const props = withDefaults(defineProps<Props>(), {
  as: 'button',
  loading: false,
  loadingLabel: undefined,
})
</script>

<template>
  <Primitive
    data-slot="button"
    :data-variant="variant"
    :data-size="size"
    :as="as"
    :as-child="asChild"
    :data-loading="loading || undefined"
    :disabled="loading || undefined"
    :aria-busy="loading || undefined"
    :class="cn(buttonVariants({ variant, size }), loading && 'relative pointer-events-none', props.class)"
  >
    <template v-if="loading">
      <span class="inline-flex items-center gap-2 opacity-0">
        <slot />
      </span>
      <span class="absolute inset-0 flex items-center justify-center">
        <Spinner :label="loadingLabel" />
      </span>
    </template>
    <slot v-else />
  </Primitive>
</template>
